"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "caption2StrongClassNames", {
    enumerable: true,
    get: function() {
        return _useCaption2StrongStylesstyles.caption2StrongClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Caption2Strong"), exports);
const _useCaption2StrongStylesstyles = require("./useCaption2StrongStyles.styles");
